import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import api from '@/services/api'

export default function ForgotPasswordPage() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const forgotMutation = useMutation({
    mutationFn: (data: { email: string }) => api.auth.forgotPassword(data),
    onSuccess: () => setSent(true),
    onError: (err: any) => {
      setError(err.response?.data?.error?.message || err.response?.data?.message || 'Something went wrong. Please try again.')
    },
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    forgotMutation.mutate({ email })
  }

  if (sent) {
    return (
      <div className="container" style={{ maxWidth: '450px', margin: '4rem auto', padding: '2rem' }}>
        <div className="card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>&#9993;</div>
          <h1 style={{ marginBottom: '0.75rem' }}>Check your email</h1>
          <p style={{ color: 'var(--color-gray-600)', marginBottom: '1.5rem', lineHeight: '1.6' }}>
            If an account with <strong>{email}</strong> exists, we've sent a password reset link.
            Check your inbox and spam folder.
          </p>
          <button
            onClick={() => navigate('/auth')}
            style={{ width: '100%' }}
          >
            Back to Sign In
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="container" style={{ maxWidth: '450px', margin: '4rem auto', padding: '2rem' }}>
      <div className="card">
        <h1 style={{ textAlign: 'center', marginBottom: '0.5rem' }}>
          Forgot password?
        </h1>
        <p style={{ textAlign: 'center', color: 'var(--color-gray-600)', marginBottom: '2rem' }}>
          Enter your email and we'll send you a reset link.
        </p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div>
            <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem' }}>
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              style={{ width: '100%' }}
            />
          </div>

          <button
            type="submit"
            disabled={forgotMutation.isPending}
            style={{ width: '100%', marginTop: '0.5rem' }}
          >
            {forgotMutation.isPending ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
          <button
            onClick={() => navigate('/auth')}
            style={{
              background: 'transparent',
              color: 'var(--primary-color)',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Back to Sign In
          </button>
        </div>
      </div>
    </div>
  )
}
